module.exports = __webpack_public_path__ + "assets/img/9122-es.svg";